export default __webpack_public_path__ + "static/media/head02_th_sp.a725751f.png";